import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Chevron Down Stroke
 */

export default function ChevronDownStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M2.13518 4.14645C2.31542 3.95118 2.60765 3.95118 2.7879 4.14645L8 9.79289L13.2121 4.14645C13.3923 3.95118 13.6846 3.95118 13.8648 4.14645C14.0451 4.34171 14.0451 4.65829 13.8648 4.85355L8.32636 10.8536C8.14612 11.0488 7.85389 11.0488 7.67364 10.8536L2.13518 4.85355C1.95494 4.65829 1.95494 4.34171 2.13518 4.14645Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
